<pace-forms-accordion *ngIf="contentVisible$ | async" [group]="group$ | async" [open]="open" [id]="groupId$ | async">
    <ng-template #heading>
        <div class="g-0 row align-items-center">
            <span class="col-auto content-icon {{ answers$ | async | statusIcon }}"></span>
            <span class="col" [innerHTML]="headingText$ | async"></span>
        </div>
    </ng-template>
    <ng-container *ngIf="enableIndividualization$ | async">
        <ng-template #actionButton>
            <ul class="navbar-nav mx-lg-3">
                <li class="nav-item" *ngIf="(visibilityButton$ | async) === true && (isTopicIndividualizable$ | async)">
                    <button
                        class="btn btn-secondary"
                        type="button"
                        (click)="updateTopicVisibility(false)"
                        [tooltip]="'TOOLTIP_TOPIC_VISIBLE' | translate"
                        aria-label="'TOOLTIP_TOPIC_VISIBLE' | translate"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faEye"></fa-icon>
                    </button>
                </li>
                <li
                    class="nav-item"
                    *ngIf="(visibilityButton$ | async) === false && (isTopicIndividualizable$ | async)"
                >
                    <button
                        class="btn btn-secondary"
                        type="button"
                        (click)="updateTopicVisibility(true)"
                        [tooltip]="'TOOLTIP_TOPIC_HIDDEN' | translate"
                        aria-label="'TOOLTIP_TOPIC_HIDDEN' | translate"
                        triggers="hover"
                        #tooltip="bs-tooltip"
                    >
                        <fa-icon [icon]="faEyeSlash"></fa-icon>
                    </button>
                </li>
            </ul>
        </ng-template>
    </ng-container>
    <ng-container *ngIf="open">
        <ng-template #body>
            <div *ngrxLet="heading$; let heading">
                <form
                    class="form-inline mb-3"
                    *ngIf="(readOnly$ | async) === false && (autofillCheckpoints$ | async)?.length > 1"
                >
                    <div class="mb-3">
                        <label
                            [attr.for]="heading.chapterNumber"
                            class="col-form-label me-2"
                            translate="F4M_CONTENT_RENDER_AUTOFILL_CHECKPOINT_LABEL"
                        ></label>
                        <pace-forms-dropdown
                            *ngrxLet="radioButtonLabels$; let radioButtonLabels"
                            [id]="heading.chapterNumber"
                        >
                            <li role="menuitem">
                                <a class="dropdown-item" (click)="onAstoriaAutofillClick(radioOptionsTypes.YES)">{{
                                    radioButtonLabels.yes
                                }}</a>
                            </li>

                            <li role="menuitem">
                                <a class="dropdown-item" (click)="onAstoriaAutofillClick(radioOptionsTypes.NO)">{{
                                    radioButtonLabels.no
                                }}</a>
                            </li>
                            <li role="menuitem">
                                <a class="dropdown-item" (click)="onAstoriaAutofillClick(radioOptionsTypes.NA)">{{
                                    radioButtonLabels.na
                                }}</a>
                            </li>
                        </pace-forms-dropdown>
                    </div>
                </form>
                <form
                    class="form-inline mb-3"
                    *ngIf="(readOnly$ | async) === false && (autofillFunctionalElements$ | async)?.length > 1"
                >
                    <div class="mb-3">
                        <label
                            [attr.for]="heading.chapterNumber"
                            class="col-form-label me-2"
                            translate="F4M_CONTENT_RENDER_AUTOFILL_CHECKPOINT_LABEL"
                        ></label>
                        <pace-forms-dropdown
                            *ngrxLet="radioButtonLabels$; let radioButtonLabels"
                            [id]="heading.chapterNumber"
                        >
                            <li role="menuitem">
                                <a
                                    class="dropdown-item"
                                    (click)="onCosimaAutofillClick(choicesTypes.CHOICE_POSITIVE)"
                                    >{{ radioButtonLabels.yes }}</a
                                >
                            </li>
                            <li role="menuitem">
                                <a
                                    class="dropdown-item"
                                    (click)="onCosimaAutofillClick(choicesTypes.CHOICE_NEGATIVE)"
                                    >{{ radioButtonLabels.no }}</a
                                >
                            </li>
                            <li role="menuitem">
                                <a class="dropdown-item" (click)="onCosimaAutofillClick(choicesTypes.CHOICE_NA)">{{
                                    radioButtonLabels.na
                                }}</a>
                            </li>
                        </pace-forms-dropdown>
                    </div>
                </form>

                <ng-container *ngFor="let child of children$ | async; trackBy: trackByFn">
                    <pace-checkpoint
                        *ngIf="child.type === contentType.CHECKPOINT"
                        [checkpoint]="child.id"
                        [parentForm]="parentForm"
                    ></pace-checkpoint>
                    <pace-functional-element
                        *ngIf="child.type === contentType.FUNCTIONAL"
                        [id]="child.id"
                        [parentForm]="parentForm"
                    ></pace-functional-element>
                    <pace-content-renderer
                        *ngIf="child.type === contentType.CONTENT"
                        [contentId]="child.id"
                        [parentForm]="parentForm"
                    ></pace-content-renderer>
                </ng-container>
            </div>
        </ng-template>
    </ng-container>
    <ng-template #closer>
        <div role="link" [innerHTML]="closer$ | async"></div>
    </ng-template>
</pace-forms-accordion>
